/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';

import Text from '@redbubble/design-system/react/Text';
import { MEDIUM } from '@redbubble/favourite-icon';
import '@redbubble/favourite-icon/lib/styles.css';

import WorkAttribution from '../WorkAttribution';
import styles from './WorkDetails.css';
import ProtectedImage from '../ProtectedImage';
import FavoriteButton from '../FavoriteButton';
import Svg from '../Svg';
import ProductRecommendations from '../ProductRecommendations';
import rightArrow from '../Artist/rightArrow.svg.raw';
import withAnalytics from '../../containers/redux/withAnalytics';
import { UniqueWithinTypeDecode } from '../../apollo/uniqueWithinType';
import {
  analyticsPayload,
  EXPLORE_SHOP_AVAILABLE_PRODUCTS
} from '../../lib/analytics';
import messages from './messages';

const FavoriteButtonAnalytics = withAnalytics(FavoriteButton);

class WorkDetails extends Component {
  render() {
    const { work, analyticsLabel, userInfo, logEvent } = this.props;

    const workId = UniqueWithinTypeDecode(work.id);

    const { availableProductCount } = work;
    const showShopAvailableProducts = availableProductCount > 1;

    return (
      <div className={styles.workcontainer}>
        <div className={styles.workview}>
          <ProtectedImage
            src={work.modalImage.url}
            title={work.title}
            width={work.modalImage.width}
            height={work.modalImage.height}
            protectionDiv
          />
        </div>
        <div className={styles.workdetails}>
          <div className={styles.artistdetails}>
            <WorkAttribution work={work} logEvent={logEvent} />
            <div className={styles.workactions}>
              <FavoriteButtonAnalytics
                isLoggedIn={get(userInfo, 'isLoggedIn', false)}
                size={MEDIUM}
                id={workId}
                favorited={work.isFavorited || false}
                analyticsLabel={analyticsLabel}
                imgUrl={work.modalImage.url}
              />
            </div>
          </div>
          <ProductRecommendations workId={workId} userInfo={userInfo} />
          {showShopAvailableProducts && (
            <Text
              type="display5"
              onClick={() => {
                logEvent({
                  analytics: analyticsPayload.workPageView(
                    EXPLORE_SHOP_AVAILABLE_PRODUCTS
                  )
                });
              }}
            >
              <a href={work.url} className={styles.productlink}>
                <FormattedMessage
                  {...messages.ShopAvailableProducts}
                  values={{ availableProductCount }}
                />
                <Svg
                  className={styles.availableProductsArrow}
                  svg={rightArrow}
                />
              </a>
            </Text>
          )}
        </div>
      </div>
    );
  }
}

WorkDetails.propTypes = {
  work: PropTypes.shape({
    id: PropTypes.string.isRequired,
    modalImage: PropTypes.shape({
      url: PropTypes.string.isRequired,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired
    }),
    title: PropTypes.string.isRequired,
    isFavorite: PropTypes.bool
  }),
  userInfo: PropTypes.shape({
    userId: PropTypes.string
  }),
  logEvent: PropTypes.func
};

WorkDetails.defaultProps = {
  userInfo: {
    userId: null
  },
  logEvent: () => {}
};

WorkDetails.displayName = 'WorkDetails';

WorkDetails.fragment = gql`
  fragment WorkDetails on Work {
    id
    title
    isFavorited
    availableProductCount
    modalImage {
      url
      width
      height
    }
    ...${WorkAttribution.displayName}
  }
  ${WorkAttribution.fragment}
`;

export default WorkDetails;
